import "app/Instrumentation"; // Sentry initialization should be imported first
import React from "react";
import ReactDOM from "react-dom/client";
import "@mediamath/design-system-eng/dist/main.css";
import "styles/themes/t1next/theme.scss";
import "primeicons/primeicons.css";
import Root from "app/Root";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(<Root />);
